/**
 * Rollt `row` in die Mitte des Scrollers und hält sie dort fest (`pin` aus `useScrollAnchor`).
 *
 * Für den Sprung aus „Favoriten“ (#210): Beim Öffnen hält Demnächst „Heute“ fest, bis der Nutzer
 * selbst scrollt — ein Rollen per Code zählt nicht. Gingen danach die Aufgaben-Details auf oder
 * luden Monate nach, rückte der Anker die Liste zurück zu „Heute“ (gemeldet 01.10.2026: klappte
 * erst beim zweiten Klick). Festgehalten wird deshalb die Zeile selbst.
 */
export function scrollRowAndPin({ scrollEl, row, pin, minOffset }: {
  scrollEl: HTMLElement
  row: HTMLElement
  pin: (el: HTMLElement, offset: number) => void
  /** Mindestabstand zur Oberkante — unter dem Verlauf oben. */
  minOffset: number
}): void {
  const rowRect = row.getBoundingClientRect()
  const offset = Math.max(minOffset, (scrollEl.clientHeight - rowRect.height) / 2)
  const rowOffset = rowRect.top - scrollEl.getBoundingClientRect().top
  pin(row, offset)
  scrollEl.scrollTo({ top: scrollEl.scrollTop + rowOffset - offset, behavior: 'smooth' })
}
